import { render, staticRenderFns } from "./SelecionarRequisicao.vue?vue&type=template&id=006e3ae5&"
import script from "./SelecionarRequisicao.vue?vue&type=script&lang=js&"
export * from "./SelecionarRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports